import React from 'react';
import classNames from 'classnames';
import { AccordionDetails as MuiAccordionDetails } from '@material-ui/core';
import { makeStyles } from "../../styles/index";
var useStyles = makeStyles({
    root: {
        backgroundColor: function (props) { return props.backgroundColor; },
        padding: 0,
        borderRadius: 0,
    },
}, { name: 'SnAccordionDetails' });
export var AccordionDetails = function (props) {
    var children = props.children, classes = props.classes, className = props.className, style = props.style;
    var detailsClasses = useStyles(props);
    return (React.createElement("div", { className: classNames(detailsClasses.root, className) },
        React.createElement(MuiAccordionDetails, { children: children, classes: classes, style: style })));
};
